<template>
    <div class="portlet light borderless">
        <div class="portlet-title">
            <div class="caption">
                <span class="caption-subject bold uppercase" v-if="item">
                    {{ item.name }} - <small> Edit </small>
                </span>
                <span class="caption-subject bold uppercase" v-if="!item">
                    Config Item <small v-if="!item"> New </small>
                </span>
            </div>
        </div>
        <div class="portlet-body">
            <div class="row">
                <div class="col-md-6 col-md-offset-2">
                    <div class="form-horizontal">
                        <div class="form-group" :class="{'has-error': form.errors.has('name')}">
                            <label class="col-md-4 control-label">Name</label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" v-model="form.name">
                                <span class="help-block" v-if="form.errors.has('name')" v-text="form.errors.get('name')"></span>
                            </div>
                        </div>
                        <div class="form-group" :class="{'has-error': form.errors.has('slug')}">
                            <label class="col-md-4 control-label">Slug</label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" v-model="form.slug">
                                <span class="help-block" v-if="form.errors.has('slug')" v-text="form.errors.get('slug')"></span>
                            </div>
                        </div>

                        <div class="form-group" :class="{'has-error': form.errors.has('slug')}">
                            <div class="col-md-8 col-md-offset-4">
                                <div class="mt-checkbox-list">
                                    <label class="mt-checkbox mt-checkbox-outline">
                                        <input type="checkbox" v-model="form.isSingleValued"> Is single valued
                                        <span></span>
                                    </label>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-md-12">
                    <h4>Fields</h4>
                    <hr>

                    <div class="field-line" v-for="(field, index) in form.fields">
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group" :class="{'has-error': form.errors.has(`fields.${index}.name`)}">
                                    <label class="control-label">Name</label>
                                    <input type="text" class="form-control" placeholder="Field name" v-model="form.fields[index].name">
                                    <span class="help-block" v-if="form.errors.has(`fields.${index}.name`)" v-text="form.errors.get(`fields.${index}.name`)"></span>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group" :class="{'has-error': form.errors.has(`fields.${index}.slug`)}">
                                    <label class="control-label">Slug</label>
                                    <input type="text" class="form-control" placeholder="Field slug" v-model="form.fields[index].slug">
                                    <span class="help-block" v-if="form.errors.has(`fields.${index}.slug`)" v-text="form.errors.get(`fields.${index}.slug`)"></span>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="form-group" :class="{'has-error': form.errors.has(`fields.${index}.type`)}">
                                    <label class="control-label">Type</label>
                                    <select class="form-control" v-model="form.fields[index].type">
                                        <option value>Select type...</option>
                                        <option value="text">Text</option>
                                        <option value="textarea">Textarea</option>
                                        <option value="date">Date</option>
                                    </select>
                                    <span class="help-block" v-if="form.errors.has(`fields.${index}.type`)" v-text="form.errors.get(`fields.${index}.type`)"></span>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <button class="btn btn-xs btn-outline dark" style="margin-top: 30px;" v-if="index !== 0" @click="removeField(index)">
                                    <i class="glyphicon glyphicon-minus"></i>
                                </button>
                            </div>
                        </div>
                    </div>

                    <button class="btn btn-md btn-outline dark" @click="addField">
                        <i class="glyphicon glyphicon-plus"></i> Add field
                    </button>
                    <hr>
                </div>
            </div>

            <button class="btn btn-md btn-outline dark" @click="save()">
                <i class="glyphicon glyphicon-ok"></i> Save
            </button>
        </div>
    </div>
</template>

<script>
    import Form from 'services/form/Form'

    export default {
        name: "config-item-add-edit",

        props: {
            item: {
                type: Object
            }
        },

        data() {
            return {
                form: new Form()
            }
        },

        computed: {
            saveUrl() {
                return this.item ? Sincron.routes.route('config.update', {config: this.item.id}) : Sincron.routes.route('config.store')
            }
        },

        watch: {
            item: function(item) {
                this.setForm(item)
            }
        },

        methods: {
            addField() {
                this.form.fields.push({
                    name: null,
                    slug: null,
                    type: 'text'
                })
            },

            removeField(index) {
                this.form.fields.splice(index, 1)
            },

            defaultFormObject() {
                return {
                    name: null,
                    slug: null,
                    isSingleValued: true,
                    fields: [
                        {
                            name: 'Value', slug: 'value', type: 'text'
                        }
                    ]
                }
            },

            itemFormObject(item) {
                return {
                    name: item.name,
                    slug: item.slug,
                    isSingleValued: item.is_single_valued,
                    fields: item.fields
                }
            },

            setForm(item) {
                if (item) {
                    this.form = new Form(this.itemFormObject(item))
                } else {
                    this.form = new Form(this.defaultFormObject())
                }
            },

            async save() {
                try {
                    let response = await this.form.post(this.saveUrl)
                    this.$toaster.success(response.message)
                    this.$parent.$emit('refresh')

                    if (!this.item) {
                        this.item = response.item
                    }
                } catch (error) {
                    this.$toaster.error(error.message ? error.message : 'Error')
                }
            }
        },

        mounted() {
            this.setForm(this.item);
        }
    }
</script>
